<div id="{{ widgetId }}" class="vtr-widget-device-recover-bad-sectors">
	<div class="container-fluid">
		<div class="row">
			<div class="col">
				<div class="row title-box">
					<h2 id="{{ widgetId }}-title" role="heading" class="title">{{ title }}</h2>
					<!-- This div is being used to avoid screen reader to read this content without stop -->
					<div>
						<vtr-ui-question-mark-button
							[componentId]="widgetId"
							[tooltipText]="description"
							tooltipId="{{ widgetId }}-tooltip-text"
							ariaLabel="recover-bad-sectors-tooltip, which reads: {{ description }}">
						</vtr-ui-question-mark-button>
					</div>
				</div>
				<p id="{{ widgetId }}-description" role="text" class="description">{{ 'hardwareScan.recoverBadSectors.waitAvailability' | translate }}</p>
			</div>
		</div>
		<div class="row">
			<div class="col">
				<div class="button-row">
					<vtr-material-button
						linkId="{{ widgetId }}-btn"
						[label]="'hardwareScan.recoverBadSectors.title' | translate | uppercase"
						[isDisabled]="disable"
						[tooltipText] ="tooltipText"
						(buttonClick)="onRecoverBadSectors()"
						heightSize="lg">
					</vtr-material-button>
				</div>
			</div>
		</div>
	</div>
</div>
